module.exports = __webpack_public_path__ + "img/icon-optional-view@2x.d391d9af.png";